// extracted by mini-css-extract-plugin
export var about_media = "style-module--about_media--862f8";
export var about_section = "style-module--about_section--814dd";
export var article_section = "style-module--article_section--6e449";
export var more_btn = "style-module--more_btn--75ee5";
export var photoBox = "style-module--photoBox--cee31";
export var reason_section = "style-module--reason_section--5fed7";
export var section_content = "style-module--section_content--2efdb";
export var section_description = "style-module--section_description--98e8a";
export var section_heading = "style-module--section_heading--5de30";
export var service_item = "style-module--service_item--214ab";
export var service_section = "style-module--service_section--7835a";
export var slideImg = "style-module--slideImg--abe27";
export var textBox = "style-module--textBox--4eafa";
export var top_visual = "style-module--top_visual--1493c";